import styled from 'styled-components';
import { m, p } from '@upgrade/react-components/Spacing/core';

export const StyledImage = styled.img`
  width: 100%;
`;

export const StyledInfoColumn = styled.div`
  @media (min-width: ${props => props.theme.mediaSm}) {
    max-width: 19rem;
  }
`;

export const StyledLinksColumn = styled.div`
  @media (min-width: ${props => props.theme.mediaSm}) {
    max-width: 12.5rem;
  }
`;

export const StyledPartnerLinksList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  list-style-type: none;
  ${p('none')}
  ${m('none')}
`;
